/*
 * GoalImport Messages
 *
 * This contains all the text for the GoalImport component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  selectFile: {
    id: 'app.components.ImportSheet.selectFile',
    defaultMessage: 'Select File',
  },
  selectSheet: {
    id: 'app.components.ImportSheet.selectSheet',
    defaultMessage: 'Sheet',
  },
  selectFileIntro: {
    id: 'app.components.SelectFiles.selectFileIntro',
    defaultMessage: 'Your file must have the following columns, you can use <a>our template</a>:',
  },
  dataField: {
    id: 'app.components.SelectFiles.dataField',
    defaultMessage: 'Data Field',
  },
  sheetColumn: {
    id: 'app.components.SelectFiles.sheetColumn',
    defaultMessage: 'Column in Sheet',
  },
});
